import { formatDate } from "@/lib/utils.ts";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface StatsData {
  label: string;
  date?: string;
  value: string | number;
  type?: string;
}

interface StatsProps {
  stats: StatsData[];
}

export function Stats({ stats }: StatsProps) {
  return (
    <div className="inline-flex h-24 items-start justify-start rounded-xl border border-neutral-200 bg-white">
      {stats.map((stat, index) => {
        return (
          <>
            <div className="inline-flex shrink grow basis-0 flex-col items-center justify-center gap-2 self-stretch p-3">
              <div className="flex items-center justify-center gap-1 self-stretch text-center text-xs font-normal leading-tight text-black">
                {stat.label}
                {stat.type && (
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger>
                        <Info className="h-3 w-3 text-zinc-500" />
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>{stat.type}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                )}
              </div>
              <div className="text-base font-bold leading-tight text-black">
                {stat.value}
              </div>
              {stat.date && (
                <div className="self-stretch text-center text-xs font-normal leading-tight text-zinc-600">
                  {stat.date ? formatDate(stat.date) : ""}
                </div>
              )}
            </div>
            {index < stats.length - 1 && (
              <div className="flex w-px items-start justify-start self-stretch">
                <div className="relative h-24 w-px rounded-full bg-neutral-200" />
              </div>
            )}
          </>
        );
      })}
    </div>
  );
}
